/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetCustomDetectionRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetCustomDetectionRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetCustomDetectionRuleSecurity = {
  option1?: GetCustomDetectionRuleSecurityOption1 | undefined;
  option2?: GetCustomDetectionRuleSecurityOption2 | undefined;
};

export type GetCustomDetectionRuleRequest = {
  /**
   * The custom detection rule ID.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetCustomDetectionRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetCustomDetectionRuleSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetCustomDetectionRuleSecurityOption1$Outbound,
    GetCustomDetectionRuleSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getCustomDetectionRuleSecurityOption1ToJSON(
  getCustomDetectionRuleSecurityOption1: GetCustomDetectionRuleSecurityOption1,
): string {
  return JSON.stringify(
    GetCustomDetectionRuleSecurityOption1$outboundSchema.parse(
      getCustomDetectionRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type GetCustomDetectionRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetCustomDetectionRuleSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetCustomDetectionRuleSecurityOption2$Outbound,
    GetCustomDetectionRuleSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getCustomDetectionRuleSecurityOption2ToJSON(
  getCustomDetectionRuleSecurityOption2: GetCustomDetectionRuleSecurityOption2,
): string {
  return JSON.stringify(
    GetCustomDetectionRuleSecurityOption2$outboundSchema.parse(
      getCustomDetectionRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type GetCustomDetectionRuleSecurity$Outbound = {
  Option1?: GetCustomDetectionRuleSecurityOption1$Outbound | undefined;
  Option2?: GetCustomDetectionRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetCustomDetectionRuleSecurity$outboundSchema: z.ZodMiniType<
  GetCustomDetectionRuleSecurity$Outbound,
  GetCustomDetectionRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetCustomDetectionRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetCustomDetectionRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getCustomDetectionRuleSecurityToJSON(
  getCustomDetectionRuleSecurity: GetCustomDetectionRuleSecurity,
): string {
  return JSON.stringify(
    GetCustomDetectionRuleSecurity$outboundSchema.parse(
      getCustomDetectionRuleSecurity,
    ),
  );
}

/** @internal */
export type GetCustomDetectionRuleRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetCustomDetectionRuleRequest$outboundSchema: z.ZodMiniType<
  GetCustomDetectionRuleRequest$Outbound,
  GetCustomDetectionRuleRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getCustomDetectionRuleRequestToJSON(
  getCustomDetectionRuleRequest: GetCustomDetectionRuleRequest,
): string {
  return JSON.stringify(
    GetCustomDetectionRuleRequest$outboundSchema.parse(
      getCustomDetectionRuleRequest,
    ),
  );
}
